import { capitalizeFirstLetter } from "../../utils/util";
import { MedicalReportStatus } from "../../utils/constants";

const MedicalReportAppointmentResult = ({
  medicalReportAppointmentData,
  selectedAppointmentData,
  setSelectedAppointmentData,
  isAppointmentSelect,
  translationMap,
  showEligiableMrMessage

}) => {

  const handleChange = (medicalData) => {
    Object.keys(medicalData)?.forEach((key) => {
      var replacedKey = key?.replace(/\s+/g, "_");
      if (key !== replacedKey) {
        medicalData[replacedKey] = medicalData[key];
        delete medicalData[key];
      }
    });
    setSelectedAppointmentData(medicalData);
  };


  return (
    <>
            {medicalReportAppointmentData &&
      <div className="dropdown-options">
                    {!isAppointmentSelect &&
        <div className="show-hide Sub_Inner_Select_Box" id="option3">
                            <div className="title_box">
                                <h6 className="Gray_Title">{translationMap?.pleaseSelectSpecialty}</h6>
                            </div>
                        </div>
        }
                    {isAppointmentSelect &&
        <div className="show-hide Sub_Inner_Select_Box" id="option1">
                            <div className="title_box">
                                <h6 className="Gray_Title">
                                    {translationMap?.latestAppointmentAvailable}
                                </h6>
                            </div>
                            {showEligiableMrMessage &&
          <div className="Info_Note_Box">
                        <span className="icon_box">
                            <i className="material-symbols-outlined">
                                info
                            </i>
                        </span>
                                    <div className="content_box">
                                        <p>
                                            {translationMap?.appointmentNotEligible}
                                        </p>
                                    </div>
                                </div>
          }
                            <div className="radio_main_wrap">
                                {medicalReportAppointmentData?.map((medicalData, index) => {
              let status = medicalData?.lrStatus;
              if (status && status.toUpperCase() === MedicalReportStatus.processed) {
                status = translationMap?.inProgress;
              } else if (status && status.toUpperCase() === MedicalReportStatus.initiated) {
                status = translationMap?.paymentWaitingMessage;
              }
              const value = index + 1;
              return <div className="custom_radio_box" key={index}>
                                        <label
                  htmlFor={`radiobox${value}`}
                  className={`radio_label ${!medicalData?.isEligible ? "radio_disabled" : ""}`}
                  value={value}>
                  
                                            <input
                    onClick={() => handleChange(medicalData)}
                    type="radio"
                    id={`radiobox${value}`}
                    className="input-radio"
                    name="doctor"
                    disabled={!medicalData?.isEligible}
                    checked={
                    selectedAppointmentData?.DATE === medicalData?.DATE &&
                    selectedAppointmentData?.PROVIDER === medicalData?.PROVIDER
                    } />
                  
                                            <div className="informtion_box">
                                                <div className="informtion_box_inner">
                                                    <h6 className="Gray_Title" style={{ direction: 'ltr' }}>
                                                        {/* 14 October 2023 */}
                                                        {new Intl.DateTimeFormat('en-GB', {
                          day: '2-digit',
                          month: 'long',
                          year: 'numeric'
                        }).format(new Date(medicalData.DATE))}
                                                    </h6>
                                                    <div className="mr_card_status">
                                                        <h3>{status}</h3>
                                                    </div>
                                                </div>
                                                <h5 className="Info_Title">

                                                    {capitalizeFirstLetter(medicalData.PROVIDER)}
                                                </h5>
                                                <p>
                                                    <b> {translationMap?.specialty}: {" "}</b>
                                                    {/* Physical Medicine and Rehabilitation */}
                                                    {medicalData.SPECIALTY}
                                                </p>
                                                <p>
                                                    <b> {translationMap?.facility}: {" "} </b>
                                                    {/* Al Barsha Health Center */}
                                                    {medicalData.LOCATION}
                                                </p>
                                            </div>
                                        </label>
                                    </div>;
            })}
                            </div>
                        </div>
        }
                </div>
      }
        </>);

};

export default MedicalReportAppointmentResult;